<script setup lang="ts">
import { useSelectChangeReason } from '../../../model/additional-info/support/info-change-tutor/select-change-reason.hook'
import ListTaskInfo from '../../task-info/ListTaskInfo.vue'
import RowTaskInfo from '../../task-info/RowTaskInfo.vue'
import SelectChangeReason from './info-change-tutor/SelectChangeReason.vue'

defineOptions({
  name: 'InfoChangeTutor',
})

const { isRequired } = useSelectChangeReason()

</script>

<template>
  <ListTaskInfo>
    <RowTaskInfo
      title="Change reason"
      :required="isRequired"
    >
      <SelectChangeReason />
    </RowTaskInfo>
  </ListTaskInfo>
</template>
